import React, { useState, useEffect } from "react";
import Axios from "axios";
import "./../../../../assets/css/purchase/form.css";

// React DateTime
import Datetime from "react-datetime";
import moment from "moment";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import ArModal from "../../../components/Modal/ArModal";
import SoModal from "../../../components/Modal/SoModal";
import Summary from "../../../components/Footer/Summary";
import FormAction from "../../../components/Actions/FormAction";
import PaymentModal from "../../../components/Modal/PaymentModal";

// Model
import { biMasterModel } from "../../../../model/SellProducts/BiMasterModel";
import { biDetailModel } from "../../../../model/SellProducts/BiDetailModel";

import {
  getData,
  getDataWithComp,
  formatCurrency,
  parseCurrency,
  getAlert,
  getMaxDocNoByDate,
  deleteData,
  randomDelay,
  updateQty,
  getMaxRecNoForInv,
} from "../../../../utils/SamuiUtils";

import {
  formatThaiDateUi,
  formatDateOnChange,
  formatStringDateToDate,
  formatThaiDateUiToDate,
  formatDateToStringDate,
  setCreateDateTime,
  getCreateDateTime,
} from "../../../../utils/DateUtils";

import { InvoiceHandleSubmit } from "../../../../utils/InvoiceUtils";
import {
  manageWhArPaymentData,
  setRemarkByPaymentType,
} from "../../../../utils/PaymentUtils";
import ViewSoModal from "../../../components/Modal/ViewSoModal";

const FormWater = ({ callInitialize, mode, name, docNo, getReport }) => {
  const [formMasterList, setFormMasterList] = useState(biMasterModel());
  const [displayDocNo, setDisplayDocNo] = useState(docNo);
  const [formDetailList, setFormDetailList] = useState([]);
  const [soDataList, setSoDataList] = useState([]);
  const [arDataList, setArDataList] = useState([]);

  // การแสดงสถานะเอกสาร
  const [statusPaidName, setStatusPaidName] = useState("");
  const [statusPaidColour, setStatusPaidColour] = useState("");

  // การคำนวณเงิน
  const [selectedDiscountValueType, setSelectedDiscountValueType] =
    useState("2");
  const [totalPrice, setTotalPrice] = useState(0);
  const [receiptDiscount, setReceiptDiscount] = useState(0);
  const [subFinal, setSubFinal] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [isVatChecked, setIsVatChecked] = useState(false);
  const [vatAmount, setVatAmount] = useState(0);

  // สำหรับเก็บประเภทการชำระเงิน
  const [paymentType, setPaymentType] = useState(null);
  const [paymentAmount, setPaymentAmount] = useState("full");
  const [specifiedAmount, setSpecifiedAmount] = useState(0);
  const [base64Image, setBase64Image] = useState("");

  // ใช้สำหรับคำนวณยอดรวมใหม่ที่ตาราง
  const [soTotal, setSoTotal] = useState(0);
  const [soTotalVat, setSoTotalVat] = useState(0);
  const [soNetTotal, setSoNetTotal] = useState(0);

  useEffect(() => {
    initialize();
  }, []);

  useEffect(() => {
    if (mode !== "I" || !formMasterList.docDate) {
      setDisplayDocNo(docNo);
      return;
    }

    let isActive = true;

    const updateDisplayDocNo = async () => {
      try {
        const masterList = await getDataWithComp(
          "API_1301_BL_H",
          "ORDER BY Doc_No DESC"
        );
        const nextDocNo = getMaxDocNoByDate(
          masterList,
          "BI",
          formMasterList.docDate
        );

        if (isActive) {
          setDisplayDocNo(nextDocNo);
        }
      } catch (error) {
        console.error("Unable to update BI document number", error);
      }
    };

    updateDisplayDocNo();

    return () => {
      isActive = false;
    };
  }, [formMasterList.docDate, mode, docNo]);

  const initialize = async () => {
    const soDataList = await getDataWithComp(
      "API_0701_SO_H",
      `
          AND Doc_Is_INV = 'N' 
          AND Doc_Status_Paid = '2' 
          AND Doc_Status <> '13' 
          AND Doc_Status_Paid_Type = '4' 
          ORDER BY Doc_No DESC
      `
    );
    if (soDataList && soDataList.length > 0) {
      const filteredSoDataList = [];

      for (const soData of soDataList) {
        const filterSoData = await getData("BL_D", `SO_Id = ${soData.Doc_ID}`);
        if (!filterSoData || filterSoData.length === 0) {
          filteredSoDataList.push(soData);
        }
      }

      setSoDataList(filteredSoDataList);
    }

    const arDataList = await getDataWithComp(
      "Tb_Set_AR",
      "ORDER BY AR_Code ASC"
    );
    if (arDataList && arDataList.length > 0) {
      setArDataList(arDataList);
    }

    // สำหรับ View เข้ามาเพื่อแก้ไขข้อมูล
    if (mode === "U") {
      await getModelByNo(arDataList);
    }
  };

  const getModelByNo = async (arDataList) => {
    try {
      const fromDatabase = await getDataWithComp(
        "API_1301_BL_H",
        `AND Doc_No = '${docNo}'`
      );

      if (!fromDatabase) {
        throw new Error("ไม่พบข้อมูลเอกสาร");
      }

      // ค้นหาข้อมูลผู้ขายด้วย AR_ID
      const fromViewAr = arDataList.find(
        (ap) => ap.AR_Id === fromDatabase[0].AR_ID
      );

      if (!fromViewAr) {
        throw new Error("ไม่พบข้อมูลลูกค้า");
      }

      setStatusPaidName(fromDatabase[0].DocBLStatusPaid_Name);
      setStatusPaidColour(fromDatabase[0].DocBLStatusPaid_Colour);

      // ค้นหาข้อมูลของ Detail ด้วย Doc_Id
      const fromDetail = await getData(
        "API_1302_BL_D",
        `Doc_Id = ${fromDatabase[0].Doc_Id}`
      );

      if (!fromDetail) {
        throw new Error("ไม่พบข้อมูลรายละเอียดเอกสาร");
      }

      // const createNewRow = (index, itemSelected) => {
      //   return {
      //     ...biDetailModel(index + 1),
      //     soId: itemSelected.SO_Id,
      //     soNo: itemSelected.SO_No,
      //     soDocDate: itemSelected.SO_Date,
      //     arName: itemSelected.AR_Name,
      //     remark: itemSelected.SO_Doc_Remark_1,
      //     netTotal: formatCurrency(itemSelected.Item_Total),
      //     totalVat: formatCurrency(itemSelected.Total_Vat),
      //   };
      // };

      if (fromDetail.length > 0) {
        // const newFormDetails = fromDetail.map((item, index) => createNewRow(formDetailList.length + index, item));

        // เรียงลำดับ newFormDetails โดยใช้ netTotal
        // newFormDetails.sort((a, b) => {
        //   // ใช้ parseFloat ในการแปลงเป็นตัวเลขเพื่อให้การเรียงลำดับทำงานได้ถูกต้อง
        //   return parseFloat(a.netTotal.replace(/[^0-9.-]+/g, '')) - parseFloat(b.netTotal.replace(/[^0-9.-]+/g, ''));
        // });

        // setFormDetailList(newFormDetails);

        if (fromDetail && fromDetail.length > 0) {
          for (const detail of fromDetail) {
            let fromViewSo = await getData(
              "API_0701_SO_H",
              `Doc_ID = ${detail.SO_Id}`
            );
            await onRowSelectSo(fromViewSo);
          }
        }

        const data = fromDatabase[0];

        setIsVatChecked(data.BL_Is_Vat === 1 ? true : false);

        setFormMasterList({
          docId: data.Doc_Id,
          compId: data.Comp_Id,
          docNo: data.Doc_No,
          docDate: formatThaiDateUi(data.Doc_Date || null),
          docDueDate: formatThaiDateUi(data.Doc_Due_Date || null),
          docStatus: data.Doc_Status,
          docPaidStatus: data.Doc_Paid_Status,
          arID: data.AR_ID,
          arCode: data.AR_Code,
          arName: data.AR_Name,
          createdDate: setCreateDateTime(data.Created_Date),
          createdByName: data.Created_By_Name,
          createdById: data.Created_By_Id,
          updateDate: getCreateDateTime(),
          updateByName: window.localStorage.getItem("name"),
          updateById: window.localStorage.getItem("emp_id"),
          cancelDate: setCreateDateTime(data.Cancel_Date),
          cancelByName: data.Cancel_By_Name,
          cancelById: data.Cancel_By_Id,
          blTotal: data.BL_Total,
          blDis: data.BL_Dis,
          blIsVat: data.BL_Is_Vat,
          blVat: data.BL_Vat,
          blNetTotal: data.BL_Net_Total,
          docIsInv: data.Doc_Is_INV,
          docInvNo: data.Doc_INV_No,
          docIsInvFrom: data.Doc_Is_INV_From,
          discountValue: data.Discount_Value,
          discountValueType: data.Discount_Value_Type,
          docPaidPic: data.Doc_Paid_Pic,
          docStatusPaidType: data.Doc_Status_Paid_Type,
          docRemark1: data.Doc_Remark1,
          docRemark2: data.Doc_Remark2,

          // ใช้สำหรับแสดงเฉยๆ
          arAdd1: fromViewAr.AR_Add1,
          arAdd2: fromViewAr.AR_Add2,
          arAdd3: fromViewAr.AR_Add3,
          arProvince: fromViewAr.AR_Province,
          arZipcode: fromViewAr.AR_Zipcode,
          arTaxNo: fromViewAr.AR_TaxNo,
        });
      } else {
        getAlert(
          "FAILED",
          `ไม่พบข้อมูลที่ตรงกับเลขที่เอกสาร ${fromDatabase[0].WHDoc_No} กรุณาตรวจสอบและลองอีกครั้ง`
        );
      }
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  const handleCheckboxChange = (event) => {
    const { name } = event.target;
    setSelectedDiscountValueType(
      selectedDiscountValueType === name ? null : name
    );
  };

  const handleChangeMaster = (e) => {
    const { name, value } = e.target;
    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeDateMaster = (value, name) => {
    // ตรวจสอบว่า value เป็น moment object หรือไม่
    const newValue =
      value && value instanceof moment ? value.format("YYYY-MM-DD") : value;
    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: formatDateOnChange(newValue),
    }));
  };

  // SET AR
  const [showArModal, setShowArModal] = useState(false);
  const handleArShow = () => setShowArModal(true);
  const handleArClose = () => setShowArModal(false);
  const onRowSelectAr = (arSelected) => {
    try {
      setFormMasterList({
        ...formMasterList,
        arID: arSelected.AR_Id,
        arCode: arSelected.AR_Code,
        arName: arSelected.AR_Name,
        arAdd1: arSelected.AR_Add1,
        arAdd2: arSelected.AR_Add2,
        arAdd3: arSelected.AR_Add3,
        arProvince: arSelected.AR_Province,
        arZipcode: arSelected.AR_Zipcode,
        arTaxNo: arSelected.AR_TaxNo,
      });

      handleArClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // SET SO
  const [showSoModal, setShowSoModal] = useState(false);
  const handleSoShow = () => setShowSoModal(true);
  const handleSoClose = () => setShowSoModal(false);
  const onRowSelectSo = async (soSelected) => {
    try {
      // ล้างข้อมูลเก่าก่อน
      if (mode === "I") {
        setFormDetailList([]);
      }

      // เคลียร์ค่า VAT ด้วย
      setIsVatChecked(false);

      let soTotal = 0;
      let soTotalVat = 0;

      const createNewRow = (index, itemSelected) => {
        let netTotal = parseFloat(itemSelected.NetTotal) || 0;
        let itemTotal = itemSelected.IsVat === 1 ? netTotal / 1.07 : netTotal;
        let totalVat = itemSelected.IsVat === 1 ? netTotal - itemTotal : 0.0;

        // const itemDiscount = parseFloat(itemSelected.Item_Discount) || 0;
        // const itemDisType = String(itemSelected.Item_DisType);
        // const totalDiscount = itemDisType === '2' ? (itemDiscount / 100) * itemTotal : itemDiscount;

        // if (itemDisType === '2') {
        //   itemTotal -= (itemDiscount / 100) * itemTotal; // ลดตามเปอร์เซ็นต์
        // } else {
        //   itemTotal -= itemDiscount; // ลดตามจำนวนเงิน
        // }

        // setReceiptDiscount(totalDiscount);

        if (itemSelected.IsVat === 1) {
          setIsVatChecked(true);
        }

        // ทำการคำนวณยอดรวมของใบขายใหม่อีกครั้งนะครับ
        soTotal += itemSelected.Total_Before_Vat;
        soTotalVat += itemSelected.VAT;

        return {
          ...biDetailModel(index + 1),
          soId: itemSelected.Doc_ID,
          soNo: itemSelected.Doc_No,
          soDocDate: itemSelected.Doc_Date,
          arName: itemSelected.AR_Name,
          remark: itemSelected.Doc_Remark1,
          itemTotal: formatCurrency(itemTotal),
          netTotal: formatCurrency(netTotal),
          totalVat: formatCurrency(totalVat),
        };
      };

      // สร้างรายการใหม่โดยการคำนวณจาก soSelected
      const newFormDetails = soSelected.map((item, index) =>
        createNewRow(formDetailList.length + index, item)
      );

      // อัปเดตยอดรวมที่คำนวณเสร็จ
      setSoTotal(soTotal);
      setSoTotalVat(soTotalVat);
      setSoNetTotal(soTotal + soTotalVat);

      // เรียงลำดับ newFormDetails โดยใช้ netTotal
      newFormDetails.sort((a, b) => {
        // ใช้ parseFloat ในการแปลงเป็นตัวเลขเพื่อให้การเรียงลำดับทำงานได้ถูกต้อง
        return (
          parseFloat(a.netTotal.replace(/[^0-9.-]+/g, "")) -
          parseFloat(b.netTotal.replace(/[^0-9.-]+/g, ""))
        );
      });

      // อัปเดต formDetailList
      if (mode === "I") {
        setFormDetailList(newFormDetails);
      } else {
        setFormDetailList((prev) => [...prev, ...newFormDetails]);
      }
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  const onConfirmSoSelection = async (soSelected) => {
    try {
      if (!soSelected[0]) {
        getAlert("FAILED", "ท่านยังไม่ได้เลือกใบขายสินค้า");
        return;
      }

      // ใช้สำหรับดักเรื่องใบขายมีการใช้ VAT ต่างกัน
      for (const soData of soSelected) {
        if (Number(soData.IsVat) !== Number(soSelected[0].IsVat)) {
          getAlert("FAILED", "กรุณาเลือกใบขายประเภทเดียวกัน");
          return;
        }
      }

      setFormDetailList([]);
      onRowSelectSo(soSelected);
      handleSoClose();

      // แจ้งเตือนผู้ใช้ว่าการเลือกสำเร็จ
      getAlert("OK", "การเลือกใบขายสินค้าสำเร็จ");
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  const handleSubmit = async () => {
    try {
      // ทดสอบหน่วงเวลาก่อนบันทึก (ทดสอบป้องกันการซ้ำของ Doc_No)
      await randomDelay();

      const masterList = await getDataWithComp(
        "API_1301_BL_H",
        `ORDER BY Doc_No DESC`
      );
      let newMaxOd = docNo;

      if (masterList && masterList.length > 0) {
        const maxBi = getMaxDocNoByDate(
          masterList,
          "BI",
          formMasterList.docDate
        );
        newMaxOd = maxBi;
      }
      setDisplayDocNo(newMaxOd);

      // ตรวจสอบค่า formMasterList.apID และ formMasterList.apCode
      if (!formMasterList.arID && !formMasterList.arCode) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบผู้ขาย");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า apID หรือ apCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบรายละเอียดใบขาย");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        comp_id: window.localStorage.getItem("company"),
        doc_no: newMaxOd,
        doc_date: formatStringDateToDate(formMasterList.docDate),
        doc_due_date: formatStringDateToDate(formMasterList.docDueDate),
        doc_status: 1,
        doc_paid_status: 0,
        ar_id: formMasterList.arID,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: window.localStorage.getItem("name"),
        created_by_id: window.localStorage.getItem("emp_id"),
        update_date: null,
        update_by_name: null,
        update_by_id: null,
        cancel_date: null,
        cancel_by_name: null,
        cancel_by_id: null,
        bl_total: totalPrice,
        bl_dis: receiptDiscount,
        bl_is_vat: isVatChecked ? parseInt("1", 10) : parseInt("2", 10),
        bl_vat: vatAmount,
        bl_net_total: grandTotal,
        doc_is_inv: parseInt("0", 10),
        doc_inv_no: null,
        doc_is_inv_from: null,
        discount_value: parseFloat(formMasterList.discountValue || 0.0),
        discount_type: parseInt(selectedDiscountValueType, 10),
        doc_paid_pic: null,
        doc_status_paid_type: null,
        doc_remark1: formMasterList.docRemark1,
        doc_remark2: formMasterList.docRemark2,
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/create-bi-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (response.data.status === "OK") {
        const getDocIdResponse = await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/get-by-doc-no`,
          {
            table: "BL_H",
            doc_no: formMasterData.doc_no,
            comp_id: window.localStorage.getItem("company"),
          },
          {
            headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
          }
        );

        if (getDocIdResponse && getDocIdResponse.data.length > 0) {
          const docId = parseInt(getDocIdResponse.data[0].Doc_Id, 10);

          const detailPromises = formDetailList.map(async (item) => {
            const formDetailData = {
              doc_id: docId,
              so_id: item.soId,
            };

            return Axios.post(
              `${process.env.REACT_APP_API_URL}/api/create-bi-d`,
              formDetailData,
              {
                headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
              }
            );
          });

          await Promise.all(detailPromises);
        }

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleUpdate = async () => {
    try {
      // ตรวจสอบค่า formMasterList.apID และ formMasterList.apCode
      if (!formMasterList.arID && !formMasterList.arCode) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบผู้ขาย");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า apID หรือ apCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบรายละเอียดใบขาย");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        comp_id: formMasterList.compId,
        doc_no: formMasterList.docNo,
        doc_date: formatStringDateToDate(formMasterList.docDate),
        doc_due_date: formatStringDateToDate(formMasterList.docDueDate),
        doc_status: parseInt(formMasterList.docStatus, 10),
        doc_paid_status: parseInt(formMasterList.docPaidStatus, 10),
        ar_id: formMasterList.arID,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: formMasterList.createdByName,
        created_by_id: formMasterList.createdById,
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        cancel_date: formatThaiDateUiToDate(formMasterList.cancelDate),
        cancel_by_name: formMasterList.cancelByName,
        cancel_by_id: formMasterList.cancelById,
        bl_total: totalPrice,
        bl_dis: receiptDiscount,
        bl_is_vat: isVatChecked ? parseInt("1", 10) : parseInt("2", 10),
        bl_vat: vatAmount,
        bl_net_total: grandTotal,
        doc_is_inv: parseInt("0", 10),
        doc_inv_no: formMasterList.docInvNo,
        doc_is_inv_from: formMasterList.docIsInvFrom,
        discount_value: parseFloat(formMasterList.discountValue || 0.0),
        discount_type: parseInt(selectedDiscountValueType, 10),
        doc_paid_pic: formMasterList.docPaidPic,
        doc_status_paid_type: formMasterList.docStatusPaidType,
        doc_remark1: formMasterList.docRemark1,
        doc_remark2: formMasterList.docRemark2,
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-bi-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (response.data.status === "OK") {
        // ลบข้อมูลเดิมก่อนจะเริ่มการบันทึกใหม่
        await deleteData(
          "BL_D",
          `WHERE Doc_ID = ${parseInt(formMasterList.docId, 10)}`
        );

        const detailPromises = formDetailList.map(async (item) => {
          const formDetailData = {
            doc_id: parseInt(formMasterList.docId, 10),
            so_id: item.soId,
          };

          return Axios.post(
            `${process.env.REACT_APP_API_URL}/api/create-bi-d`,
            formDetailData,
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );
        });

        await Promise.all(detailPromises);

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleCancel = async () => {
    try {
      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        doc_no: formMasterList.docNo,
        doc_status: parseInt("13", 10),
        cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
        cancel_by_name: window.localStorage.getItem("name"),
        cancel_by_id: window.localStorage.getItem("emp_id"),
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-bi-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (response.data.status === "OK") {
        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleTax = async () => {
    try {
      const response = await InvoiceHandleSubmit(
        "BI", // BI = ใบวางบิล, SO = ใบขาย
        formMasterList.arID, // arId
        formMasterList.arCode, // arCode
        formMasterList.arName, // arName
        formMasterList.arTaxNo, // arTaxNo
        formMasterList.arAdd1, // arAdd1
        formMasterList.arAdd2, // arAdd2
        formMasterList.arAdd3, // arAdd3
        formMasterList.arProvince, // arProvince
        formMasterList.arZipcode, // arZipcode
        null, // arContact1
        null, // arContact2
        null, // arTel1
        null, // arTel2
        formMasterList.docDate, // docDate
        1, // docFor
        formMasterList.docId, // refDocId
        formMasterList.docNo, // refDoc
        formMasterList.docDate, // refDocDate
        formMasterList.docRemark1, // docRemark1
        isVatChecked // isVat
      );

      callInitialize();
      getAlert(response.data.status, response.data.message);
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const [showPayTypeModal, setShowPayTypeModal] = useState(false);
  const handlePayTypeShow = () => setShowPayTypeModal(true);
  const handlePayTypeClose = () => {
    setShowPayTypeModal(false);

    // รีเซ็ตค่า state ตามต้องการ
    setPaymentType(null);
    setPaymentAmount("full");
    setSpecifiedAmount(0);
  };
  const handleUploadSlip = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64Image(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleUpdatePayment = async () => {
    try {
      // ตรวจสอบค่าว่าเลือกประเภทการชำระเงินหรือยัง
      if (!paymentType) {
        getAlert("FAILED", "กรุณาเลือกประเภทการชำระเงิน");
        return; // หยุดการทำงานของฟังก์ชันหากไม่ได้เลือกประเภทการชำระเงิน
      }

      // ตรวจสอบว่าถ้าเลือกประเภทการชำระเงินสดและโอน กรอกจำนวนเงินยัง ?
      if (paymentType === "1" || paymentType === "2") {
        if (
          !parseCurrency(specifiedAmount) ||
          parseCurrency(specifiedAmount) === 0
        ) {
          getAlert("FAILED", "กรุณากรอกจํานวนเงินที่ชำระเงิน");
          return; // หยุดการทำงานของฟังก์ชันหากไม่ได้กรอกจํานวนเงินที่ชำระเงิน
        }
      }

      // เช็คเงื่อนไขสำหรับการชำระเงินด้วยการโอน
      let paidStatus = formMasterList.docPaidStatus;
      if ((paymentType === "1" || paymentType === "2") && specifiedAmount) {
        const specifiedAmountNum = parseFloat(specifiedAmount);
        const grandTotalNum = parseFloat(grandTotal);

        if (isNaN(specifiedAmountNum) || isNaN(grandTotalNum)) {
          getAlert("FAILED", "จำนวนเงินที่ระบุไม่ถูกต้อง");
          return; // หยุดการทำงานหากจำนวนเงินไม่ถูกต้อง
        }

        if (specifiedAmountNum < grandTotalNum) {
          paidStatus = 1; // ค้างจ่าย
        } else if (specifiedAmountNum > grandTotalNum) {
          getAlert("FAILED", "ไม่สามารถจ่ายเกินยอดได้");
          return; // หยุดการทำงานของฟังก์ชันถ้า specifiedAmount มากกว่า grandTotal
        } else {
          paidStatus = 2; // จ่ายครบแล้ว
        }
      } else if (paymentType === "3") {
        // สมมติว่า 2 คือประเภทการชำระเงินแบบเช็ค
        paidStatus = 1; // ค้างจ่าย
      } else if (paymentType === "4") {
        // สมมติว่า 2 คือประเภทการชำระเงินแบบเครดิต
        paidStatus = 1; // ค้างจ่าย
      } else if (paymentType === "5") {
        // สมมติว่า 2 คือประเภทการชำระเงินแบบค้างจ่าย
        paidStatus = 1; // ค้างจ่าย
      } else {
        paidStatus = 2; // จ่ายครบแล้ว
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formPaidData = {
        doc_status: parseInt("5", 10),
        doc_paid_status: parseInt(paidStatus, 10),
        doc_status_paid_type: parseInt(paymentType, 10),
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        doc_no: formMasterList.docNo,
        comp_id: window.localStorage.getItem("company"),
        doc_paid_pic: base64Image,
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-bi-paid`,
        formPaidData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        // เพิ่ม Business มาใหม่ By SpriteZadis
        for (const formDetail of formDetailList) {
          // เอาใบขายที่เก็บอยู่ใน BL_D มาหยอดสถานะว่า 'จ่ายแล้ว'
          await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/update-so-paid-complete`,
            {
              doc_status_paid: parseInt("3", 10),
              update_date: formatThaiDateUiToDate(getCreateDateTime()),
              update_by_name: window.localStorage.getItem("name"),
              update_by_id: window.localStorage.getItem("emp_id"),
              doc_no: formDetail.soNo,
              comp_id: window.localStorage.getItem("company"),
              pay_total: parseCurrency(specifiedAmount),
            },
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );

          // เอาใบขายที่เก็บอยู่ใน BL_D ไปอัพเดทค่าที่ WH_ARPAYMENT_Onhand & WH_ARPAYMENT_STC
          // ค้นหาข้อมูลล่าสุด และทำการอัพเดตค่าใน PAYMENT_ONHAND & PAYMENT_STC
          // ต้องเป็นจ่ายครบเท่านั้น
          // if (paidStatus === 2) {
          //   const getSoData = await getDataWithComp(
          //     "API_0701_SO_H",
          //     `AND Doc_No = '${formDetail.soNo}'`
          //   );
          //   if (getSoData && getSoData.length > 0) {
          //     for (const soData of getSoData) {
          //       // ปรับยอดเงินเข้า
          //       await manageWhArPaymentData(
          //         soData.AR_ID, // AR_ID ของลูกค้านั้นๆ
          //         soData.AR_Code, // AR_Code ของสิ่งนั้นๆ
          //         soData.AR_Name, // ชื่อลูกค้าคนนั้นๆ
          //         0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
          //         "AI", // ประเภท เช่น AI/AO
          //         soData.NetTotal, // ค่าจำนวนเงิน
          //         soData.Doc_ID, // ไอดีเอกสาร
          //         soData.Doc_No, // เลขเอกสาร
          //         formMasterList.docNo, // เลขเอกสารอ้างอิง
          //         await setRemarkByPaymentType(parseFloat(soData.Doc_Status_Paid_Type)), // หมายเหตุ
          //       );
          //     }
          //   }
          // }
        }

        // ทดสอบหน่วงเวลาก่อนบันทึก (ทดสอบป้องกันการซ้ำของ Doc_No)
        await randomDelay();

        // รันเลข REC ที่ Doc_INV_No ล่าสุด
        // หาค่าสูงของ RecNo ใน REC_H
        const findMaxRecNo = await getDataWithComp(
          "BL_H",
          `AND Doc_INV_No LIKE 'REC%' ORDER BY Doc_INV_No DESC`
        );
        let maxRec = getMaxRecNoForInv(findMaxRecNo);

        const formUpdateData = {
          table: "BL_H",
          doc_is_inv: parseInt("0", 10),
          doc_inv_no: maxRec,
          doc_is_inv_from: parseInt("0", 10),
          where: `WHERE Doc_Id = ${formMasterList.docId}`,
        };

        await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/update-invoice`,
          formUpdateData,
          {
            headers: { key: "SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999" },
          }
        );

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };
  // ใช้สำหรับปรับสถานะที่เป็น 'ค้างจ่าย' ให้เป็น 'จ่ายครบ' (เฉพาะเช็ค)
  const handleUpdatePaidStatus = async () => {
    try {
      // ข้อมูลหลักที่จะส่งไปยัง API
      const formUpdateData = {
        doc_paid_status: parseInt("2", 10),
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        doc_no: formMasterList.docNo,
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-bi-paid-complete`,
        formUpdateData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        // เอาใบขายที่เก็บอยู่ใน BL_D ไปอัพเดทค่าที่ WH_ARPAYMENT_Onhand & WH_ARPAYMENT_STC
        // for (const formDetail of formDetailList) {
        //   const getSoData = await getDataWithComp(
        //     "API_0701_SO_H",
        //     `AND Doc_No = '${formDetail.soNo}'`
        //   );
        //   if (getSoData && getSoData.length > 0) {
        //     for (const soData of getSoData) {
        //       // ปรับยอดเงินเข้า
        //       await manageWhArPaymentData(
        //         soData.AR_ID, // AR_ID ของลูกค้านั้นๆ
        //         soData.AR_Code, // AR_Code ของสิ่งนั้นๆ
        //         soData.AR_Name, // ชื่อลูกค้าคนนั้นๆ
        //         0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
        //         "AI", // ประเภท เช่น AI/AO
        //         soData.NetTotal, // ค่าจำนวนเงิน
        //         soData.Doc_ID, // ไอดีเอกสาร
        //         soData.Doc_No, // เลขเอกสาร
        //         formMasterList.docNo, // เลขเอกสารอ้างอิง
        //         await setRemarkByPaymentType(parseFloat(soData.Doc_Status_Paid_Type)), // หมายเหตุ
        //       );
        //     }
        //   }
        // }

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  // เปิด Modal สำหรับดูรายละเอียดใบขาย
  const [showViewSoModal, setShowViewSoModal] = useState(false);
  const [selectedSoData, setSelectedSoData] = useState(null);
  const handleViewSoClose = () => {
    setShowViewSoModal(false);
    setSelectedSoData(null);

    // ลบ class 'modal-open' จาก body
    document.body.classList.remove("modal-open");

    // ลบ element ที่อาจถูกซ้อน เช่น backdrop ของ Modal
    const backdrops = document.getElementsByClassName("modal-backdrop");
    while (backdrops.length > 0) {
      backdrops[0].parentNode.removeChild(backdrops[0]);
    }
  };
  const handleViewSo = (soData) => {
    setSelectedSoData(soData);
    setShowViewSoModal(true);
  };

  // การคำนวณยอดรวม (totalPrice)
  useEffect(() => {
    const total = formDetailList.reduce(
      (acc, item) => acc + (parseCurrency(item.itemTotal) || 0),
      0
    );
    setTotalPrice(total);
  }, [formDetailList]);

  // การคำนวณ VAT (vatAmount)
  useEffect(() => {
    const vat = isVatChecked ? totalPrice * 0.07 : 0;
    setVatAmount(parseFloat(vat.toFixed(2)));
  }, [totalPrice, isVatChecked]);

  // การคำนวณส่วนลด (receiptDiscount)
  useEffect(() => {
    let discountValue = parseFloat(formMasterList.discountValue || 0);
    let discountType = String(formMasterList.discountType || "2");
    let receiptDiscount = 0;

    if (discountType === "2") {
      // เปอร์เซ็นต์
      receiptDiscount = ((totalPrice + vatAmount) / 100) * discountValue;
    } else if (discountType === "1") {
      // จำนวนเงิน
      receiptDiscount = discountValue;
    }

    setReceiptDiscount(receiptDiscount);
  }, [
    totalPrice,
    vatAmount,
    formMasterList.discountValue,
    selectedDiscountValueType,
  ]);

  // การคำนวณยอดหลังหักส่วนลด (subFinal)
  useEffect(() => {
    const subFinal = totalPrice - receiptDiscount;
    setSubFinal(subFinal);
  }, [totalPrice, receiptDiscount]);

  // การคำนวณยอดรวมทั้งสิ้น (grandTotal)
  useEffect(() => {
    const grandTotal = subFinal + vatAmount;
    setGrandTotal(parseFloat(grandTotal));
  }, [subFinal, vatAmount]);

  return (
    <>
      <Breadcrumbs
        page={displayDocNo}
        isShowStatus={mode === "U"}
        statusName={statusPaidName}
        statusColour={statusPaidColour}
        items={[
          { name: "งานบัญชี", url: "/account" },
          { name: name, url: "/bill" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
        docIsINV={formMasterList.docIsInv}
        onHandleClick={() => getReport("bi1", docNo)}
        onHandleInvoice1={() => getReport("inv1", formMasterList.docInvNo)}
        onHandleInvoice2={() => getReport("inv2", formMasterList.docInvNo)}
        urlImg={formMasterList.docPaidPic}
      />
      <div
        className="hidden-scrollbar"
        style={{ maxHeight: "auto", overflowY: "auto" }}
      >
        <div className="body">
          <div class="container-fluid my-4">
            <h5 className="">{name}</h5>
            <div className="row mb-1">
              <div className="col-4">
                <div className="d-flex">
                  <label>วันที่เอกสาร : </label>
                  <Datetime
                    className="input-spacing-input-date"
                    name="whDocDate"
                    value={formMasterList.docDate || null}
                    onChange={(date) => handleChangeDateMaster(date, "docDate")}
                    dateFormat="DD-MM-YYYY"
                    timeFormat={false}
                    inputProps={{ readOnly: true, disabled: mode === "U" }}
                  />
                </div>
              </div>
              <div className="col-4 text-left">
                <div className="d-flex align-items-center">
                  <label>ลูกค้า</label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control input-spacing"
                      name="apCode"
                      value={
                        (formMasterList.arCode || "") +
                        " " +
                        (formMasterList.arName || "")
                      }
                      onChange={handleChangeMaster}
                      disabled={true}
                    />
                    <button
                      className="btn btn-outline-secondary"
                      onClick={handleArShow}
                      disabled={mode === "U" ? true : false}
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                </div>
                <ArModal
                  showArModal={showArModal}
                  handleArClose={handleArClose}
                  arDataList={arDataList}
                  onRowSelectAr={onRowSelectAr}
                />
              </div>
              <div className="col-4">
                <div className="d-flex">
                  <label>สร้างโดย : </label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    value={formMasterList.createdByName}
                    disabled={true}
                  />
                </div>
              </div>
            </div>
            <div className="row mb-1">
              <div className="col-4">
                <div className="d-flex">
                  <label>รายละเอียดเอกสาร : </label>
                  {/* <input
                    type="text"
                    className="form-control input-spacing"
                    name="docRemark1"
                    value={formMasterList.docRemark1 || ""}
                    onChange={handleChangeMaster}
                    disabled={formMasterList.docIsInv === 1}
                  /> */}
                  <textarea
                    type="text"
                    className=" input-spacing"
                    name="docRemark1"
                    value={formMasterList.docRemark1 || ""}
                    onChange={handleChangeMaster}
                    style={{ height: "65px" }}
                    disabled={formMasterList.docIsInv === 1}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="d-flex align-items-center">
                  <label>ที่อยู่</label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    name="apAdd1"
                    value={formMasterList.arAdd1 || ""}
                    onChange={handleChangeMaster}
                    disabled={true}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="d-flex">
                  <label className="">วันที่สร้าง : </label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    value={formMasterList.createdDate}
                    disabled={true}
                  />
                </div>
              </div>
            </div>
            <div className="row mb-1">
              <div className="col-4">
                <div className="d-flex">
                  <label>หมายเหตุธุรการ : </label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    name="docRemark2"
                    value={formMasterList.docRemark2 || ""}
                    onChange={handleChangeMaster}
                    disabled={formMasterList.docIsInv === 1}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="d-flex align-items-center">
                  <label></label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    value={
                      (formMasterList.arAdd2 || "") +
                      " " +
                      (formMasterList.arAdd3 || "")
                    }
                    disabled={true}
                  />
                </div>
              </div>
            </div>
            <div className="row mb-1">
              <div className="col-4">
                {/* <div className="d-flex">
              <label>วันที่เอกสารอ้างอิง : </label>
              <input
                //type="date"
                type="text"
                className="form-control input-spacing"
                name="refDocDate"
                value={formMasterList.refDocDate || ''}
                disabled={true}
              />
            </div> */}
              </div>
              <div className="col-4">
                <div className="d-flex align-items-center">
                  <label></label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    value={
                      (formMasterList.arProvince || "") +
                      " " +
                      (formMasterList.arZipcode || "")
                    }
                    disabled={true}
                  />
                </div>
              </div>
            </div>
            <div className="row mb-1">
              <div className="col-4">
                {/* <div className="d-flex">
              <label>หมายเหตุ : </label>
              <input
                type="text"
                className="form-control input-spacing"
                name="whDocRemark"
                value={formMasterList.whDocRemark || ''}
                onChange={handleChangeMaster}
                disabled={isDisabled} />
            </div> */}
                {/* <div className="d-flex">
              <label>จากคลัง : </label>
              <select
                class="form-select"
                value={selectedWarehouseFrom}
                onChange={(e) => handleChangeWarehouse(e.target.value, 'FROM')}>
                <option value={null}>
                  กรุณาระบุคลัง
                </option>
                {whFromDataList.map((warehouse) => (
                  <option
                    key={warehouse.WH_Id}
                    value={warehouse.WH_Id}
                  >
                    {warehouse.WH_Name}
                  </option>
                ))}
              </select>
            </div> */}
              </div>
              <div className="col-4">
                <div className="d-flex align-items-center">
                  <label>เลขที่ภาษี</label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    value={formMasterList.arTaxNo || ""}
                    disabled={true}
                  />
                </div>
              </div>
            </div>
            <div className="row mb-1">
              <div className="col-4">
                {/* <div className="d-flex">
              <label>ไปคลัง :</label>
              <select
                class="form-select"
                value={selectedWarehouseTo}
                onChange={(e) => handleChangeWarehouse(e.target.value, 'TO')}>
                <option value={null}>
                  กรุณาระบุคลัง
                </option>
                {whToDataList.map((warehouse) => (
                  <option
                    key={warehouse.WH_Id}
                    value={warehouse.WH_Id}
                  >
                    {warehouse.WH_Code} ({warehouse.WH_Name})
                  </option>
                ))}
              </select>
            </div> */}
              </div>
              <div className="col-4">
                {/* <div className="d-flex">
              <label>หมายเหตุ : </label>
              <input
                type="text"
                className="form-control input-spacing"
                name="whDocRemark"
                value={formMasterList.whDocRemark || ''}
                onChange={handleChangeMaster}
                disabled={false} />
            </div> */}
              </div>
            </div>
          </div>
          <hr />
        </div>
        <div className="container-fluid my-3">
          <div className="row">
            <div className="col-12">
              <div className="col-12">
                <div className="card">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h4 className="card-title">รายละเอียดสินค้า</h4>
                    <button
                      className="btn text-white mx-3"
                      onClick={handleSoShow}
                      style={{
                        backgroundColor: "rgb(239, 108, 0)",
                        whiteSpace: "nowrap",
                        padding: "10px",
                        fontSize: "15px",
                      }}
                      disabled={
                        formMasterList.arID === null ||
                        formMasterList.docIsInv === 1
                          ? true
                          : false
                      }
                    >
                      <i className="fa fa-plus"></i> เพิ่มรายการ
                    </button>
                    <SoModal
                      showSoModal={showSoModal}
                      handleSoClose={handleSoClose}
                      soDataList={soDataList}
                      onConfirmSoSelection={onConfirmSoSelection}
                      arId={formMasterList.arID}
                    />
                  </div>
                  <div className="card-body">
                    <div
                      className="table-responsive"
                      style={{ maxHeight: "500px", overflowY: "auto" }}
                    >
                      <table
                        id="basic-datatables"
                        className="table table-striped table-hover"
                      >
                        <thead className="thead-dark">
                          <tr>
                            <th className="text-center" style={{ width: "2%" }}>
                              #
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "10%" }}
                            >
                              เลขที่ใบขาย
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "10%" }}
                            >
                              วันที่เอกสาร
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "15%" }}
                            >
                              ชื่อลูกค้า
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "37%" }}
                            >
                              รายละเอียดสินค้า
                            </th>
                            <th className="text-center" style={{ width: "8%" }}>
                              รวมราคา
                            </th>
                            <th className="text-center" style={{ width: "8%" }}>
                              VAT
                            </th>
                            <th className="text-center" style={{ width: "8%" }}>
                              รวมสุทธิ
                            </th>
                            <th className="text-center" style={{ width: "2%" }}>
                              View
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {formDetailList.length > 0 ? (
                            formDetailList.map((item, index) => (
                              <tr key={item.itemId || index + 1}>
                                {/* # */}
                                <td className="text-center">{index + 1}</td>

                                {/* เลขที่ใบขาย */}
                                <td className="text-center">
                                  <span>{item.soNo || ""}</span>
                                </td>

                                {/* วันที่เอกสาร */}
                                <td className="text-center">
                                  <span>
                                    {formatDateToStringDate(item.soDocDate) ||
                                      ""}
                                  </span>
                                </td>

                                {/* ชื่อลูกค้า */}
                                <td className="text-left">
                                  <span>{item.arName || ""}</span>
                                </td>

                                {/* รายละเอียดสินค้า */}
                                <td className="text-left">
                                  <span>{item.remark || ""}</span>
                                </td>

                                {/* รวมราคา */}
                                <td className="text-end">
                                  <span>{item.itemTotal || 0.0}</span>
                                </td>

                                {/* VAT */}
                                <td className="text-end">
                                  <span>{item.totalVat || 0.0}</span>
                                </td>

                                {/* รวมสุทธิ */}
                                <td className="text-end">
                                  <span>{item.netTotal || 0.0}</span>
                                </td>

                                {/* View */}
                                <td className="text-center">
                                  <i
                                    className="fa fa-eye"
                                    style={{
                                      color: "#EF6C00",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => handleViewSo(item)}
                                  ></i>
                                </td>

                                {showViewSoModal && selectedSoData && (
                                  <ViewSoModal
                                    showViewSoModal={showViewSoModal}
                                    handleViewSoClose={handleViewSoClose} // ใช้ฟังก์ชันปิด Modal
                                    mode={"U"}
                                    name={`ใบขายสินค้าเลขที่ ${selectedSoData.soNo}`}
                                    maxDocNo={selectedSoData.soNo} // ส่งหมายเลขใบขาย
                                  />
                                )}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="9">
                                <center>
                                  <h5>ไม่พบรายการสินค้า</h5>
                                </center>
                              </td>
                            </tr>
                          )}
                        </tbody>
                        <tfoot>
                          <tr>
                            <td
                              colSpan="5"
                              className="text-end"
                              style={{
                                fontSize: "16px",
                                fontWeight: "bold",
                                color: "#333",
                              }}
                            >
                              <div className="text-end">
                                <span>รวมราคา</span>
                              </div>
                            </td>
                            <td
                              colSpan="1"
                              className="text-end"
                              style={{
                                fontSize: "16px",
                                fontWeight: "bold",
                                color: "#333",
                              }}
                            >
                              {/* รวมราคา */}
                              <span
                                className="text-end"
                                style={{ color: "#EF6C00" }}
                              >
                                {formatCurrency(soTotal)}
                              </span>
                            </td>
                            <td
                              colSpan="1"
                              className="text-end"
                              style={{
                                fontSize: "16px",
                                fontWeight: "bold",
                                color: "#333",
                              }}
                            >
                              {/* VAT */}
                              <span style={{ color: "#EF6C00" }}>
                                {formatCurrency(soTotalVat)}
                              </span>
                            </td>
                            <td
                              colSpan="1"
                              className="text-end"
                              style={{
                                fontSize: "16px",
                                fontWeight: "bold",
                                color: "#333",
                              }}
                            >
                              {/* รวมราคาสุทธิ */}
                              <span style={{ color: "#EF6C00" }}>
                                {formatCurrency(soNetTotal)}
                              </span>
                            </td>
                            <td colSpan="1"></td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4">
                        <h4 className="card-title">ส่วนลดท้ายบิล</h4>
                        <div className="row mt-3">
                          <div className="col-3">
                            <div className="d-flex align-items-center">
                              <label className="mr-2 flex-grow-1">
                                ส่วนลดมูลค่า
                              </label>
                            </div>
                          </div>
                          <div className="col-3">
                            <input
                              type="text"
                              className="form-control text-end"
                              name="discountValue"
                              onChange={handleChangeMaster}
                              onInput={(e) => {
                                if (/^0+/.test(e.target.value)) {
                                  e.target.value = e.target.value.replace(
                                    /^0+/,
                                    ""
                                  );

                                  // หากกรอกเฉพาะจุดทศนิยม ให้เติม 0 ด้านหน้า (เช่น .5 -> 0.5)
                                  if (e.target.value.startsWith(".")) {
                                    e.target.value = "0" + e.target.value;
                                  }
                                }
                              }}
                            />
                          </div>
                          <div className="col-3">
                            <div className="row">
                              <div className="radio-inline">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  name="2"
                                  checked={selectedDiscountValueType === "2"}
                                  onChange={handleCheckboxChange}
                                  disabled={true}
                                />
                                <label className="form-check-label">%</label>
                              </div>
                            </div>
                          </div>
                          <div className="col-3">
                            <input
                              type="text"
                              className="form-control text-end"
                              name="discountValueTotal"
                              value={receiptDiscount || ""}
                              onChange={handleChangeMaster}
                              disabled={true}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-4"></div>
                      <div className="col-4">
                        <h4 className="card-title">ยอดท้ายบิล</h4>
                        <div className="row mt-3">
                          <div className="col-12">
                            <div className="d-flex justify-content-end align-items-center mt-1">
                              <label>รวมราคา</label>
                              <input
                                type="text"
                                className="form-control text-end input-spacing"
                                style={{ width: "100px" }}
                                value={formatCurrency(totalPrice || 0)}
                                disabled={true}
                              />
                            </div>
                            <div className="d-flex justify-content-end align-items-center mt-1">
                              <label className="mr-3">VAT (7%)</label>
                              <input
                                type="text"
                                className="form-control text-end input-spacing"
                                style={{ width: "100px" }}
                                value={formatCurrency(vatAmount || 0)}
                                disabled={true}
                              />
                            </div>
                            <hr />
                            <div className="d-flex justify-content-end align-items-center mt-1">
                              <label>ราคารวมสุทธิ</label>
                              <input
                                type="text"
                                className="form-control text-end input-spacing"
                                style={{ width: "100px" }}
                                value={formatCurrency(
                                  totalPrice + vatAmount || 0
                                )}
                                disabled={true}
                              />
                            </div>
                            <div className="d-flex justify-content-end align-items-center mt-1">
                              <label>รวมส่วนลด</label>
                              <input
                                type="text"
                                className="form-control text-end input-spacing"
                                style={{ width: "100px" }}
                                value={formatCurrency(receiptDiscount || 0)}
                                disabled={true}
                              />
                            </div>
                            <hr />
                            <div className="d-flex justify-content-end align-items-center mt-1">
                              <label>
                                <h5>รวมทั้งสิ้น</h5>
                              </label>
                              <input
                                type="text"
                                className="form-control text-end input-spacing"
                                style={{
                                  width: "100px",
                                  color: "red",
                                  fontWeight: "bold",
                                  fontSize: "18px",
                                }}
                                value={formatCurrency(grandTotal || 0)}
                                disabled={true}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <PaymentModal
                show={showPayTypeModal}
                grandTotal={grandTotal}
                paymentType={paymentType}
                setPaymentType={setPaymentType}
                paymentAmount={paymentAmount}
                setPaymentAmount={setPaymentAmount}
                specifiedAmount={specifiedAmount}
                setSpecifiedAmount={setSpecifiedAmount}
                handlePayTypeClose={handlePayTypeClose}
                handleUpdatePayment={handleUpdatePayment}
                handleUploadSlip={handleUploadSlip}
                base64Image={base64Image}
              />
            </div>
          </div>
        </div>
      </div>

      <FormAction
        onSubmit={handleSubmit}
        onUpdate={handleUpdate}
        onCancel={handleCancel}
        onApprovedPay={handlePayTypeShow}
        onSubmitTax={handleTax}
        onUpdatePaid={handleUpdatePaidStatus}
        docStatus={formMasterList.docPaidStatus}
        mode={mode}
        disabled={formMasterList.docIsInv === 1 ? true : false}
        disabledInv={formMasterList.docIsInv === 1 ? true : false}
        disabledPay={false}
        footer={true}
      />
    </>
  );
};

export default FormWater;
